// src/db/seed.js
import { getAgents, addAgent, getCandidates, addCandidate, USE_SUPABASE } from './index.js'
import { logCandidateEvent } from '../lib/agentLog.js'

// Schedule is now an array of slots per day.
// [] = day off, [{start,end,location}] = single slot, [{...},{...}] = split shift
const SEED_AGENTS = [
  {
    name: 'Ana Beridze', role: 'Senior Agent', office_id: '1',
    phone: '+995 555 100 001', email: 'ana@sentavus.com',
    schedule: {
      Mon: [{ start: '09:00', end: '18:00', location: 'office' }],
      Tue: [{ start: '09:00', end: '18:00', location: 'office' }],
      Wed: [{ start: '09:00', end: '13:00', location: 'office' }, { start: '14:00', end: '18:00', location: 'home' }],
      Thu: [{ start: '09:00', end: '18:00', location: 'office' }],
      Fri: [{ start: '09:00', end: '17:00', location: 'office' }],
      Sat: [{ start: '10:00', end: '15:00', location: 'office' }],
      Sun: [],
    },
  },
  {
    name: 'Giorgi Khachidze', role: 'Agent', office_id: '1',
    phone: '+995 555 100 002', email: 'giorgi@sentavus.com',
    schedule: {
      Mon: [{ start: '10:00', end: '19:00', location: 'office' }],
      Tue: [{ start: '10:00', end: '19:00', location: 'home' }],
      Wed: [{ start: '10:00', end: '19:00', location: 'office' }],
      Thu: [],
      Fri: [{ start: '10:00', end: '19:00', location: 'office' }],
      Sat: [{ start: '10:00', end: '14:00', location: 'office' }],
      Sun: [{ start: '10:00', end: '14:00', location: 'home' }],
    },
  },
  {
    name: 'Nino Lomidze', role: 'Junior Agent', office_id: '1',
    phone: '+995 555 100 003', email: 'nino@sentavus.com',
    schedule: {
      Mon: [{ start: '09:00', end: '18:00', location: 'home' }],
      Tue: [{ start: '09:00', end: '18:00', location: 'office' }],
      Wed: [{ start: '09:00', end: '18:00', location: 'office' }],
      Thu: [{ start: '09:00', end: '18:00', location: 'office' }],
      Fri: [],
      Sat: [],
      Sun: [],
    },
  },
  {
    name: 'Davit Maisuradze', role: 'Agent', office_id: '1',
    phone: '+995 555 100 004', email: 'davit@sentavus.com',
    schedule: {
      Mon: [{ start: '08:00', end: '17:00', location: 'office' }],
      Tue: [{ start: '08:00', end: '17:00', location: 'office' }],
      Wed: [],
      Thu: [{ start: '08:00', end: '17:00', location: 'office' }],
      Fri: [{ start: '08:00', end: '13:00', location: 'office' }, { start: '14:00', end: '18:00', location: 'home' }],
      Sat: [{ start: '09:00', end: '13:00', location: 'office' }],
      Sun: [],
    },
  },
  {
    name: 'Tamar Kvaratskhelia', role: 'Senior Agent', office_id: '1',
    phone: '+995 555 100 005', email: 'tamar@sentavus.com',
    schedule: {
      Mon: [{ start: '09:30', end: '18:30', location: 'office' }],
      Tue: [{ start: '09:30', end: '18:30', location: 'office' }],
      Wed: [{ start: '09:30', end: '18:30', location: 'home' }],
      Thu: [{ start: '09:30', end: '18:30', location: 'home' }],
      Fri: [{ start: '09:30', end: '18:30', location: 'office' }],
      Sat: [{ start: '10:00', end: '15:00', location: 'home' }],
      Sun: [{ start: '11:00', end: '15:00', location: 'office' }],
    },
  },
  {
    name: 'Levan Chikavani', role: 'Agent', office_id: '1',
    phone: '+995 555 100 006', email: 'levan@sentavus.com',
    schedule: {
      Mon: [],
      Tue: [{ start: '11:00', end: '15:00', location: 'office' }, { start: '17:00', end: '21:00', location: 'home' }],
      Wed: [{ start: '11:00', end: '19:00', location: 'office' }],
      Thu: [{ start: '11:00', end: '19:00', location: 'office' }],
      Fri: [{ start: '11:00', end: '19:00', location: 'office' }],
      Sat: [{ start: '11:00', end: '16:00', location: 'office' }],
      Sun: [],
    },
  },
]

export async function seedIfEmpty() {
  // ⚠️ LOCAL DEMO MODE ONLY (attendance audit 2026-10-21): on the real database an empty read - a new office, or a
  // read that came back empty - would WRITE sample people (and their log rows) into production. Never there.
  if (USE_SUPABASE) return
  const existing = await getAgents()
  if (existing.length === 0) {
    for (const agent of SEED_AGENTS) {
      await addAgent(agent)
    }
  }
}

// ─── Candidate seed ───────────────────────────────────────────────────────────

const SEED_CANDIDATES = [
  { name: 'Mariam Gelashvili',   phone: '+995 555 201 001', email: 'mariam.g@gmail.com',   position: 'Senior Agent',  source: 'LinkedIn',  status: 'new',         interview_date: null,         interview_time: null,  interviewer: null,     notes: 'Strong background in luxury real estate.' },
  { name: 'Giorgi Tsiklauri',    phone: '+995 555 201 002', email: 'g.tsiklauri@mail.com',  position: 'Agent',         source: 'Referral',  status: 'scheduled',   interview_date: new Date(Date.now() + 2*86400000).toISOString().slice(0,10), interview_time: '11:00', interviewer: 'Ana Beridze', notes: 'Referred by Tamar.' },
  { name: 'Nino Javakhishvili',  phone: '+995 555 201 003', email: 'nino.j@gmail.com',     position: 'Junior Agent',  source: 'Website',   status: 'scheduled',   interview_date: new Date(Date.now() + 4*86400000).toISOString().slice(0,10), interview_time: '14:30', interviewer: 'Levan Chikavani', notes: null },
  { name: 'Luka Andronikashvili',phone: '+995 555 201 004', email: 'luka.a@gmail.com',     position: 'Agent',         source: 'Facebook',  status: 'interviewed', interview_date: new Date(Date.now() - 3*86400000).toISOString().slice(0,10), interview_time: '10:00', interviewer: 'Giorgi Khachidze', notes: 'Good communication skills. Confident.' },
  { name: 'Salome Beridze',      phone: '+995 555 201 005', email: 'salome.b@yahoo.com',   position: 'Senior Agent',  source: 'LinkedIn',  status: 'interviewed', interview_date: new Date(Date.now() - 5*86400000).toISOString().slice(0,10), interview_time: '15:00', interviewer: 'Ana Beridze',    notes: 'Very experienced. Negotiating offer.' },
  { name: 'Irakli Mgebrishvili', phone: '+995 555 201 006', contact_link: 'https://www.facebook.com/irakli.m', position: 'Agent', source: 'Facebook', status: 'new', interview_date: null, interview_time: null, interviewer: null, notes: 'Found via Facebook. No email yet.' },
  { name: 'Keti Svanidze',       phone: '+995 555 201 007', email: 'keti.s@gmail.com',     position: 'Junior Agent',  source: 'Job board', status: 'rejected',    interview_date: new Date(Date.now() - 10*86400000).toISOString().slice(0,10), interview_time: '09:00', interviewer: 'Davit Maisuradze', notes: 'Lacked experience for our current needs.' },
  { name: 'Tornike Chakhvadze',  phone: '+995 555 201 008', email: 'tornike.c@gmail.com',  position: 'Manager',       source: 'Referral',  status: 'new',         interview_date: new Date(Date.now() + 7*86400000).toISOString().slice(0,10), interview_time: '12:00', interviewer: 'Ana Beridze',    notes: 'Strong management background. CEO referral.' },
]

export async function seedCandidatesIfEmpty() {
  // ⚠️ LOCAL DEMO MODE ONLY (attendance audit 2026-10-21): on the real database an empty read - a new office, or a
  // read that came back empty - would WRITE sample people (and their log rows) into production. Never there.
  if (USE_SUPABASE) return
  const existing = await getCandidates()
  if (existing.length === 0) {
    for (const c of SEED_CANDIDATES) {
      const created = await addCandidate({ ...c, status: c.status || 'new' })
      logCandidateEvent(created.id, 'added', `Added${c.position ? ` for ${c.position}` : ''}${c.source ? ` via ${c.source}` : ''}.`)
      if (c.interview_date) {
        logCandidateEvent(created.id, 'scheduled', `Interview: ${c.interview_date}${c.interview_time ? ' at ' + c.interview_time : ''}${c.interviewer ? ' with ' + c.interviewer : ''}.`)
      }
      if (c.status === 'interviewed') {
        logCandidateEvent(created.id, 'interviewed', `Interview completed${c.interview_date ? ' on ' + c.interview_date : ''}.`)
      }
      if (c.status === 'rejected') {
        logCandidateEvent(created.id, 'rejected', `Rejected.${c.notes ? ' Reason: ' + c.notes : ''}`)
      }
    }
  }
}
